<template>
  <div id="footerComponent" class="container-fluid">
    <div class="row padding-div">
      <div class="col-12 headings text-center">
        <h1>Footer</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>